import { BasicDataKeys } from '../components/ListWithFixedColumns/VirtualListHelpers'
import FieldIds from '../enums/DeliveryFieldIds'
import LogisticsListKeys from '../enums/LogisticsListKeys'
import LogisticsMapKeys from '../enums/LogisticsMapKeys'

export const LogisticsDataKeys = {
  ...BasicDataKeys,
  ...LogisticsListKeys,
  ...FieldIds,
  ...LogisticsMapKeys,
}
